export default function Metric({ label, value, detail, footerLabel, footerValue, Icon, tone = "blue", testId }) {
  return <article className={`metric metric-${tone}`} data-testid={testId}>
    {Icon && <Icon className="metric-icon" size={17} weight="bold" aria-hidden="true" />}
    <span>{label}</span>
    <strong>{value}</strong>
    {footerLabel ? <div className="metric-footer"><small>{footerLabel}</small><small data-testid={`${testId}-footer-value`}>{footerValue}</small></div> : <small>{detail}</small>}
  </article>;
}